<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Imagen menú lateral:</h3>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12" align="center">
            <v-file-input
              outlined
              v-if="!appbar_image"
              v-model="appbar_image"
              @change="onAppBarImageChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen menú lateral"
              :messages="['Para una mejor visualización, usar una imagen PNG o JPG de 1080x256 px.']"
            ></v-file-input>

            <v-card
              v-if="appbar_image"
              width="256px">
              <v-img
                contain
                :src="url_appbar_image"
                class="grey lighten-2"
                height="540px"
                width="256px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteAppBarImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>

          <v-col 
            cols="12" 
            xl="6" 
            md="5" 
            sm="12">
            <h3 class="font-weight-regular">Color de texto:</h3>
            <v-radio-group v-model="appbar_dark_mode">
              <v-radio
                label="Blanco"
                :value="true"
              ></v-radio>

              <v-radio
                label="Negro"
                :value="false"
              ></v-radio>

            </v-radio-group>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :disabled="loading_update"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationAppBar',
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      customization:[],

      appbar_image: null,
      url_appbar_image: null,
      appbar_dark_mode: true,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.edition = response.data.data
          this.customization = response.data.data.customization
    
          this.appbar_image = response.data.data.customization.appbar_image
          this.url_appbar_image = APP_URL+ this.appbar_image
          this.appbar_dark_mode = (response.data.data.customization.appbar_dark_mode)?true:false

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('appbar_image', this.appbar_image)
        formData.append('appbar_dark_mode', this.appbar_dark_mode ? 1 : 0 )

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-app-bar',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_update = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
          this.loading_update=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      },

      onAppBarImageChange() {
        this.url_appbar_image = URL.createObjectURL(this.appbar_image);
      },

      deleteAppBarImage(){
        this.appbar_image=null
        this.url_appbar_image=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
